export default "__VITE_ASSET__2bffa950__"